import {
  getIsAuthenticated,
  getIsUnderReview,
  getCurrentLanguage,
} from 'ha/modules/AuthLogic/selectors';
import HttpStatus from 'ha/constants/HttpStatus';
import formatHrefURL from 'ha/utils/formatHrefURL';

const onEnterMy = store => ({ location }, replace) => {
  if (!getIsAuthenticated(store.getState())) {
    const lang = getCurrentLanguage(store.getState());
    const pathname = formatHrefURL('/login', lang);

    replace({
      ...location,
      pathname,
      query: {
        return_url: `${location.pathname}${location.search}`,
      },
      state: {
        redirectCode: HttpStatus.FOUND_REDIRECTION,
      },
    });
  }

  if (getIsUnderReview(store.getState())) {
    replace({
      ...location,
      pathname: '/under-review',
      query: {},
      search: '',
      state: {
        redirectCode: HttpStatus.FOUND_REDIRECTION,
      },
    });
  }
};

export default onEnterMy;
